import React from "react";
import BatchCert from "../../features/BatchCert/BatchCert";

const BatchCertPage = () => {
  return (
    <div className="analytics-page">
      <BatchCert />
    </div>
  );
};

export default BatchCertPage;
